const {ROOT_PATH} = require('@homeaway/search-url-parser');
const searchUrlParser = require('@homeaway/search-url-parser');
const {localizeUrl} = require('@homeaway/localization-utils');

// we need to canonicalise to thin sites (ex: homeaway.com.au --> stayz.com.au)
const mapToThinSites = {
    'www.homeaway.com.au': 'www.stayz.com.au'
};

const resolveHostName = (hostName) => mapToThinSites[hostName] || hostName;

const localeRegex = RegExp(`\[a-zA-Z]{2}-[a-zA-Z]{2}\\${ROOT_PATH}`);

module.exports = {
    isSearchRoot(pathname) {
        return (
            !!pathname &&
            (localeRegex.test(pathname) || pathname.indexOf(ROOT_PATH) === 0)
        );
    },
    buildCanonicalLink: (params, site) =>
        localizeUrl(
            searchUrlParser.toCanonicalURL(params),
            {
                hostname: resolveHostName(site.hostname),
                basePath: site.basePath
            },
            {absolute: true}
        ),
    getRefinementKey: (filters) => {
        if (filters.length === 1) {
            const filterValue = filters[0].replace('filter:', '');
            return filterValue || null;
        }
        return null;
    }
};
